
import React, { Component } from 'react';


const initData = {
    sub_heading: "HBD Chain",
    heading: "Build Web3 on The Next Generation HBD Chain",
    content: "Full-scale Blockchain Ecosystem for Metaverse & NFT Marketplace"
}

class Hero extends Component {
    state = {
        initData: {}
    }
    componentDidMount(){
        this.setState({
            initData: initData
        })
    }
    render() {
        return (
            <section className="hero-section">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                    <div className="col-12 col-md-6 col-lg-9 text-center">
                        {/* Hero Content */}
                        <div className="hero-content">
                        <div className="intro text-center mb-5">
                            <h1 className="mt-2">{this.state.initData.heading}</h1>
                            <p>{this.state.initData.content}</p>
                        </div>
                        {/* Buttons */}
                        <div className="button-group">
                            <a className="btn btn-bordered active smooth-anchor" href="#explore"><i className="icon-rocket mr-2" />Go To Documentation</a>
                            <a className="btn btn-bordered-white" href="/apply"><i className="icon-note mr-2" />Get In Touch</a>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        );
    }
}


export default Hero;

